

const Input = ({ label, required = false, error, touched, className = "", ...inputProps }) => {
  const hasError = touched && error;
  const inputId = inputProps.id || inputProps.name || `input-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <div className="w-full">
      {label && (
        <label htmlFor={inputId} className="block text-sm font-medium text-secondary mb-2">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}

      <input
        id={inputId}
        className={`w-full px-4 py-3 rounded-lg text-sm text-secondary placeholder-gray-400 
          focus:outline-none focus:ring-2 focus:ring-secondary focus:border-secondary transition-colors 
          ${hasError ? "border-red-300 bg-red-50" : "bg-grey"} 
          ${className}`}
        {...inputProps}
      />

      {hasError && <p className="mt-1.5 text-xs text-red-600">{error}</p>}
    </div>
  );
};

export default Input;
